import axios from "axios";
import React, { useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";

import Loader from "./Loader";
import DeviceKFilterExceptionForm from "./DeviceKFilterExceptionForm";
import DeviceKFilterUpstreamForm from "./DeviceKFilterUpstreamForm";

const DeviceKFilter = (props) => {
  const deviceSerial = props.deviceSerial || "UNIT12345";
  const { setError, setMessage } = props;
  const [loading, setLoading] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [openExceptionForm, setOpenExceptionForm] = useState(null);
  const [openUpstreamForm, setOpenUpstreamForm] = useState(null);

  const enableKFilter = () => {
    setLoading(true);
    axios
      .post(`/device/kfilter/enable/${deviceSerial}`)
      .then((response) => {
        setMessage("KFilter enabled successfully.");
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Error enabling KFilter");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const disableKFilter = () => {
    setLoading(true);
    axios
      .post(`/device/kfilter/disable/${deviceSerial}`)
      .then((response) => {
        setMessage("KFilter disabled successfully.");
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Error disabling KFilter");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) return <Loader />;

  return (
    <>
      <Dialog open={Boolean(confirmAction)} onClose={() => setConfirmAction(null)}>
        <DialogTitle>
          {confirmAction === "enable" ? "Enable KFilter" : "Disable KFilter"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmAction === "enable"
              ? "Do you want to enable KFilter for this device?"
              : "Do you want to disable KFilter for this device?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              confirmAction === "enable" ? enableKFilter() : disableKFilter();
              setConfirmAction(null);
            }}
            style={{
              backgroundColor: confirmAction === "enable" ? undefined : "#d32f2f",
              color: confirmAction === "enable" ? undefined : "#fff",
            }}
            color="primary"
            variant="contained"
          >
            {confirmAction === "enable" ? "Enable" : "Disable"}
          </Button>
          <Button onClick={() => setConfirmAction(null)} color="primary" variant="outlined">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {openExceptionForm && (
        <DeviceKFilterExceptionForm
          deviceSerial={deviceSerial}
          setError={setError}
          setMessage={setMessage}
          open={openExceptionForm}
          handleOpen={setOpenExceptionForm}
        />
      )}

      {openUpstreamForm && (
        <DeviceKFilterUpstreamForm
          deviceSerial={deviceSerial}
          setError={setError}
          setMessage={setMessage}
          open={openUpstreamForm}
          handleOpen={setOpenUpstreamForm}
        />
      )}

      <Box>
        <Paper style={{ padding: "16px", marginBottom: "16px" }}>
          <Typography variant="subtitle1" gutterBottom>
            KFilter Status
          </Typography>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                onClick={() => setConfirmAction("enable")}
                color="primary"
                variant="contained"
              >
                Enable KFilter
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={() => setConfirmAction("disable")}
                style={{ backgroundColor: "#d32f2f", color: "#fff" }}
                variant="contained"
              >
                Disable KFilter
              </Button>
            </Grid>
          </Grid>
        </Paper>

        <Paper style={{ padding: "16px", marginBottom: "16px" }}>
          <Typography variant="subtitle1" gutterBottom>
            KFilter Exceptions
          </Typography>
          <Grid item>
            <Button
              onClick={() => setOpenExceptionForm(true)}
              color="primary"
              variant="contained"
            >
              Add Exception
            </Button>
          </Grid>
        </Paper>

        <Paper style={{ padding: "16px" }}>
          <Typography variant="subtitle1" gutterBottom>
            KFilter Upstream Credentials
          </Typography>
          <Grid item>
            <Button
              onClick={() => setOpenUpstreamForm(true)}
              color="primary"
              variant="contained"
            >
              Set Upstream Credentials
            </Button>
          </Grid>
        </Paper>
      </Box>
    </>
  );
};

export default DeviceKFilter;
